import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Aggiungi le città che intendi personalizzare", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Attualmente non sono registrate varianti per alcuna città.", -1)
const _hoisted_4 = { class: "p-m-0" }
const _hoisted_5 = { class: "action_column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-car" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Tipologi della zona ")
const _hoisted_8 = {
  key: 0,
  class: "p-d-flex p-jc-center p-mt-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-euro-sign" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Prezzi personalizzati ")
const _hoisted_11 = { class: "p-d-flex p-ai-end" }
const _hoisted_12 = { class: "p-fluid p-mr-3" }
const _hoisted_13 = { class: "p-d-flex p-jc-center p-mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ZoneAutocompleteSelect = _resolveComponent("ZoneAutocompleteSelect")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!
  const _component_ZoneVehicleData = _resolveComponent("ZoneVehicleData")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_ZonePricingGrid = _resolveComponent("ZonePricingGrid")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_ZoneAutocompleteSelect, {
        selectedIds: _ctx.selectedIds,
        onSelectedZones: _ctx.addSelectedZones
      }, null, 8, ["selectedIds", "onSelectedZones"])
    ]),
    (!_ctx.hasZones)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          closable: false
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          value: _ctx.zones,
          dataKey: "id",
          stateKey: _ctx.stateKey,
          rows: 10,
          "rows-per-page-options": [10, 20, 50, 100],
          paginator: true,
          "striped-rows": "",
          expandedRows: _ctx.expandedRows,
          "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => (_ctx.expandedRows = $event))
        }, {
          expansion: _withCtx(({data}) => [
            _createVNode(_component_Fieldset, null, {
              legend: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ZoneVehicleData, {
                  entity: _ctx.customer,
                  zone: data,
                  showCost: false
                }, null, 8, ["entity", "zone"])
              ]),
              _: 2
            }, 1024),
            (!data.custom)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_Button, {
                    label: "Personalizza Prezzi",
                    onClick: ($event: any) => (_ctx.createCustom(data))
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            (data.custom)
              ? (_openBlock(), _createBlock(_component_Fieldset, {
                  key: 1,
                  class: "p-mt-3"
                }, {
                  legend: _withCtx(() => [
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_FloatLabel, { label: "Prezzo al Km" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputNumber, {
                              modelValue: data.custom.price_km_flat,
                              "onUpdate:modelValue": ($event: any) => (data.custom.price_km_flat = $event),
                              mode: "currency",
                              currency: "EUR",
                              class: "small_input"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createVNode(_component_ZonePricingGrid, {
                        value: data.custom,
                        config: _ctx.shapePricingConfig
                      }, null, 8, ["value", "config"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Button, {
                        label: "Ripristina standard zona",
                        icon: "pi pi-replay",
                        onClick: ($event: any) => (_ctx.restoreStandard(data))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              expander: true,
              headerStyle: {width: '3rem'}
            }),
            _createVNode(_component_Column, {
              header: "Nome",
              field: "name"
            }, {
              body: _withCtx(({data}) => [
                _createElementVNode("h5", _hoisted_4, _toDisplayString(data.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { style: {"width":"120px"} }, {
              body: _withCtx(({data}) => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_DeleteButton, {
                    onClick: ($event: any) => (_ctx.removeZone(data)),
                    title: _ctx.$t('customer.remove_zone')
                  }, null, 8, ["onClick", "title"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "stateKey", "expandedRows"]))
  ], 64))
}